angular.module('smartorg.r6.mgmts.portfolioConfiguration', []);
require('./portfolio-configuration-directive');
require('../../css/app.css');
module.exports = 'smartorg.r6.mgmts.portfolioConfiguration';
//# sourceMappingURL=app.js.map


// WEBPACK FOOTER //
// ./app/widgets/management/portfolio-configuration/app/js/plumbing/app.js